export default function(params) {
  const self = this;

  self.id = params['id'];
  self.node = params['node'].querySelector('.js-code-container');
  self.src = params['src'];
  self.init = () => {
    let request = new Kadenze.AjaxRequest({
      type: 'GET',
      data: null,
      dataType: 'text',
      dataAsJSON: false,
      url: params['src']
    });

    request.done((response) => {
      $(self.node).text(response);
      Prism.highlightElement(self.node);
      setTimeout(function() { $(window).trigger('resize'); }, 100);
    });
  };

  self.init();

  return self;
}

